import type { CategoryValidityMode } from '@/types';

/**
 * The three validity modes a requirement or upload field can pre-select for
 * the farmer (AG-249). The farmer always sees all three in the upload dialog;
 * this only decides which one is picked when it opens.
 */
export const VALIDITY_MODE_OPTIONS: ReadonlyArray<{
  value: CategoryValidityMode;
  label: string;
  hint: string;
}> = [
  { value: 'annual', label: 'Årlig', hint: 'Journaler och planer per år — årschips vid uppladdning' },
  { value: 'expires', label: 'Utgångsdatum', hint: 'Certifikat, tillstånd och besiktningar' },
  { value: 'none', label: 'Tills vidare', hint: 'Stående dokument utan slutdatum' },
];
